import { ThemeColors } from '~/themes/colors'

interface ToggleListButtonColors {
  IconButton: {
    Background: ThemeColors
    Border: ThemeColors
    Hover: {
      Background: ThemeColors
    }
    Active: {
      Background: ThemeColors
    }
  }
  Icon: {
    Disabled: {
      Color: ThemeColors
    }
  }
}

export const toggleListButtonColors: ToggleListButtonColors = {
  IconButton: {
    Background: {
      default: 'achromatic.transparent',
    },
    Border: {
      default: 'gray.400',
    },
    Hover: {
      Background: {
        default: 'gray.300',
      },
    },
    Active: {
      Background: {
        default: 'gray.400',
      },
    },
  },
  Icon: {
    Disabled: {
      Color: {
        default: 'gray.400',
      },
    },
  },
}
